import React, { useState, useEffect } from 'react'
import ZonesImport from '../presentation/ScenarioManagement/ZonesImport'

const ZonesImportWidget = ({pageParameters, navigator}) => {
    const [ file, setFile ] = useState(undefined)
    const [ zones, setZones ] = useState([])
    const [ searchTerm, setSearchTerm ] = useState('')

    // Triggers only on first load
    useEffect(() => {
        getScenarioZones()
    }, [])

    // Triggers every time there's a new file
    useEffect(() => {
        if (file && confirm(`Do you want to upload ${file && file.name}`)) {
            uploadFile()
        }
    }, [file])
    
    const handleSetSearchTerm = (e) => {
        setSearchTerm(e.target.value)
    }

    const handleSelectFile = (e) => {
        const csvFile =  e.target.files[0]
        setFile(csvFile)
    }

    const uploadFile = () => {
       const scenarioId = pageParameters && pageParameters[0]
       const formData = new FormData()
       formData.append('file', file, file.name)

       fetch(`/service/uploadZones?scenarioId=${scenarioId}`,
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            }
        ).then(response => {
            if (response.status === 200) getScenarioZones()
        }).catch(err => console.error('Error uploading CSV file', err))
    }

    const getScenarioZones = () => {
        const scenarioId = pageParameters && pageParameters[0]

        fetch(`/service/getScenario?scenarioId=${scenarioId}`, {
            method: 'GET',
            'Content-Type': 'application/json',
            credentials: 'same-origin'
        }).then(response => response.json())
          .then(scenario => setZones(scenario.zones))
          .catch(console.error)
    }

    return (
        <ZonesImport 
            handleSelectFile={handleSelectFile}
            navigator={navigator}
            currentZones={zones}
            searchTerm={searchTerm} 
            setSearchTerm={handleSetSearchTerm}
        />
    )
}

export default ZonesImportWidget